module.exports = __webpack_public_path__ + "img/three-o'clock.1d6223c5.png";